/** Valid values for network default + manual execute log level (matches backend cascade). */
export const NETWORK_LOG_LEVELS = ['ERROR', 'WARNING', 'INFO', 'DEBUG'];

export const DEFAULT_NETWORK_LOG_LEVEL = 'ERROR';

export function normalizeLogLevel(value) {
  if (value && NETWORK_LOG_LEVELS.includes(String(value).toUpperCase())) {
    return String(value).toUpperCase();
  }
  return DEFAULT_NETWORK_LOG_LEVEL;
}

/** Run tab: inherit Settings/network default when set; otherwise INFO for unsaved networks. */
export function initialRunLogLevel(network) {
  const raw = network?.logLevel;
  if (raw != null && String(raw).trim() !== '') {
    return normalizeLogLevel(raw);
  }
  return 'INFO';
}
